import type { MenuCategory, MenuProduct } from "@/mocks/branch/menu";
import ProductRow from "./ProductRow";

interface CategorySectionProps {
  category: MenuCategory;
  products: MenuProduct[];
  collapsed: boolean;
  canEditAvailability: boolean;
  canEditQuantities: boolean;
  onToggle: () => void;
  onToggleAvailable: (id: string) => void;
  onSetQuantity: (id: string, qty: number | null) => void;
  onMarkOutOfStock: (id: string) => void;
}

export default function CategorySection({
  category,
  products,
  collapsed,
  canEditAvailability,
  canEditQuantities,
  onToggle,
  onToggleAvailable,
  onSetQuantity,
  onMarkOutOfStock,
}: CategorySectionProps) {
  const availableCount = products.filter(
    (p) => p.available !== false && p.quantity !== 0,
  ).length;

  return (
    <section className="bg-background-50 rounded-card border border-background-200 overflow-hidden shadow-card">
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center gap-2.5 px-4 h-14 hover:bg-background-100 transition-colors cursor-pointer"
      >
        <div className="w-5 h-5 flex items-center justify-center text-foreground-400 shrink-0">
          <i
            className={`ri-arrow-down-s-line text-lg transition-transform duration-200 ${
              collapsed ? "-rotate-90" : ""
            }`}
          ></i>
        </div>
        <span className="font-bold text-foreground-900 truncate flex-1 min-w-0">
          {category.name}
        </span>
        <span className="text-xs text-foreground-400 font-medium whitespace-nowrap shrink-0">
          {products.length} منتج
        </span>
        <span className="text-xs text-foreground-400 font-medium whitespace-nowrap shrink-0">
          {availableCount} متوفر
        </span>
      </button>

      {!collapsed ? (
        <div className="px-3 pb-3 space-y-2">
          {products.map((product) => (
            <ProductRow
              key={product.id}
              product={product}
              canEditAvailability={canEditAvailability}
              canEditQuantities={canEditQuantities}
              onToggleAvailable={onToggleAvailable}
              onSetQuantity={onSetQuantity}
              onMarkOutOfStock={onMarkOutOfStock}
            />
          ))}
        </div>
      ) : null}
    </section>
  );
}